export const emptyStateMessageSelectAnItemToRead = "AXocsc";
export default {emptyStateMessageSelectAnItemToRead};